<div class="inline-button-toggle">
  @if (!isEditing) {
    <span class="left">
      @if (!selectedValue) {
        <a (click)="toggleEdit()" class="add-date"> Select Option </a>
      }
      @if (selectedValue) {
        <span>
          {{ selectedValue }}
        </span>
      }
      @if (selectedValue !== null) {
        <button class="edit-button" mat-icon-button (click)="toggleEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <form [formGroup]="form">
      <mat-button-toggle-group [formControl]="selectFormControl">
        @for (option of options; track option) {
          <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    </form>
    <div class="button-container">
      <button mat-button (click)="toggleEdit()">CANCEL</button>
      <button mat-button class="save" (click)="onSave()">SAVE</button>
    </div>
  </div>
</div>
